import {Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {Cliente} from '../../../model/catalogo';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'cliente-modal',
    templateUrl: './cliente-modal.component.html',
    //styleUrls: ['./cliente-modal.component.css']
})
export class ClienteModalComponent {

    constructor(private globalService: GlobalService, public modalService: ModalService, public pesquisaService: PesquisasFiltroApiService, private formBuilder: FormBuilder, private route: ActivatedRoute) {
    }

    private sub: any;

    pagina: number = 1;
    qtdPorPagina: number = 7;
    totalPaginas: number = 1;
    campoBusca = new FormControl('', []);
    tipoCliente = new FormControl('', []);
    selecionaAutomatico: boolean = false;
    matricula: boolean = false;
    resultado: Array<Cliente> = null;
    visiveis: Array<Cliente> = null;
    selecionado: Cliente = null;
    mensagemErro: string = '';

    clienteModalForm: FormGroup = this.formBuilder.group({
        campoBusca: this.campoBusca,
        tipoCliente: this.tipoCliente
    });

    ngOnInit() {
        this.mensagemErro = '';
        this.tipoCliente.setValue(1);
        this.tipoCliente.enable();
        this.campoBusca.setValue('');
        this.selecionaAutomatico = false;

        this.sub = this.route
            .queryParams
            .subscribe(params => {
                // Defaults to 0 if no query param provided.

                if (params['campoBusca'] != '') {
                    this.campoBusca.setValue(params['campoBusca']);
                }
                if (params['selecionaAutomatico'] != '') {
                    this.selecionaAutomatico = params['selecionaAutomatico'];
                }
                if (params['matricula'] != '') {
                    this.matricula = params['matricula'];
                }
                if (params['tipoCliente'] != null) {
                    this.tipoCliente.setValue(params['tipoCliente']);
                    this.tipoCliente.disable();
                    this.pesquisar();
                } else {
                    this.tipoCliente.setValue('0');
                }
            });
    }

    pesquisar() {
        let filtros: Array<any> = new Array<any>();
        let filtroItemConfiguracao: any;
        let filtroInstalacaoProduto: any;

        let userAplicacao, mci, uor;
        this.visiveis = new Array<Cliente>();
        this.resultado = new Array<Cliente>();
        this.totalPaginas = 1;

        switch (this.tipoCliente.value) {
            case '1':
                userAplicacao = {'nomeUserAplicacao': this.campoBusca.value};
                mci = null;
                uor = null;
                break;
            case '2':
                userAplicacao = null;
                mci = {'codMci': this.campoBusca.value};
                uor = null;
                break;
            case '3':
                userAplicacao = null;
                mci = null;
                //uor = { "nomeDependencia": this.campoBusca.value };
                uor = {'codUor': this.campoBusca.value};
                break;
            case '4':
                userAplicacao = {'chaveAcesso': this.campoBusca.value};
                mci = null;
                uor = null;
                break;
        }

        if (this.tipoCliente.value == 4) {

            if (!this.campoBusca.value) {
                this.mensagemErro = 'Digite a matricula do usuário!';
                return;
            }

            this.resultado = [
                {
                    codTipoCliente: 4,
                    mci: null,
                    uor: null,
                    userAplicacao:
                        {
                            codUserAplicacao: null,
                            versaoUserAplicacao: null,
                            nomeUserAplicacao: null,
                            codMci: null,
                            codUor: null,
                            chaveAcesso: this.campoBusca.value
                        }
                }
            ];

            this.selecionaCliente(this.resultado[0]);
            this.confirmar();
            return;
        }

        filtros.push({
            'filtroCliente': {
                'codTipoCliente': this.tipoCliente.value,
                'userAplicacao': userAplicacao,
                'mci': mci,
                'uor': uor
            }
        });
        filtroItemConfiguracao = {'filtros': []};
        filtroInstalacaoProduto = {'filtros': []};

        this.pesquisaService.filtraCliente(filtros)
            .subscribe(
                listaClientes => {
                    this.resultado = listaClientes as Array<Cliente>;
                    this.mudarPagina(1, 'false');
                    this.totalPaginas = Math.ceil(listaClientes.length / this.qtdPorPagina);
                    if (this.selecionaAutomatico && this.resultado.length == 1) {
                        this.selecionaCliente(this.resultado[0]);
                        this.confirmar();
                    }
                },
                erro => {
                    if (erro.status == 404) {

                    }
                }
            );
    }

    selecionaCliente(cliente: Cliente) {
        this.selecionado = cliente as Cliente;
    }

    mudarPagina(pag: number, desabilitado: string) {

        if (desabilitado == 'true') {
            return false;
        }

        this.pagina = pag;
        this.visiveis = new Array<Cliente>();
        let ind = 1;
        this.resultado.forEach(res => {
            if (ind > (pag - 1) * this.qtdPorPagina && ind <= pag * this.qtdPorPagina) {
                this.visiveis.push(res);
            }
            ind++;
        });
    }

    confirmar() {
        if (this.selecionado == null) {
            this.mensagemErro = 'Selecione o cliente ou clique em \'Fechar\'';
        } else {
            this.modalService.incluirDadosGerados(this.selecionado);
            this.modalService.fecharPaginaModal();
        }
    }

    cancelar() {
        this.modalService.fecharPaginaModal();
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/cliente-modal/cliente-modal.component.ts